import SvgIcon from '@mui/material/SvgIcon';

const AdminHeaderLogoIcon = () => {
    return (
        <SvgIcon fontSize="large">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_ii_1679_154)">
                    <rect x="6.25" y="5.9375" width="27.5" height="27.5" rx="7.34375" fill="#13335F" />
                </g>
                <foreignObject x="8.95369" y="2.32649" width="21.3661" height="19.8388">
                    <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        style={{
                            backdropFilter: 'blur(1.3px)',
                            clipPath: 'url(#bgblur_0_1679_154_clip_path)',
                            height: '100%',
                            width: '100%',
                        }}
                    />
                </foreignObject>
                <g filter="url(#filter1_i_1679_154)" data-figma-bg-blur-radius="2.59563">
                    <path
                        d="M18.4699 17.59C20.8253 20.0299 26.7955 17.7783 27.7242 19.5697C27.0688 18.1151 27.6931 17.6144 23.0764 14.3728C17.3057 10.3209 12.0008 4.19921 11.5832 4.99216C11.1656 5.7851 14.6684 13.6521 18.4699 17.59Z"
                        fill="#FF9100"
                    />
                </g>
                <foreignObject x="0.84651" y="5.97529" width="37.1529" height="28.8849">
                    <div
                        xmlns="http://www.w3.org/1999/xhtml"
                        style={{
                            backdropFilter: 'blur(1.3px)',
                            clipPath: 'url(#bgblur_1_1679_154_clip_path)',
                            height: '100%',
                            width: '100%',
                        }}
                    />
                </foreignObject>
                <g filter="url(#filter2_i_1679_154)" data-figma-bg-blur-radius="2.59563">
                    <path
                        d="M32.3309 16.4874C30.0964 16.0595 28.4554 17.3322 27.5152 18.0178C27.2975 18.1448 27.0187 18.1044 26.8604 17.9083C25.9322 16.7585 25.8841 15.9931 20.0941 14.1443C12.1938 11.6216 5.52208 7.75063 5.33555 8.7248C5.14901 9.69896 10.4212 15.9884 16.0755 19.0013C16.4597 19.2061 16.7879 19.3921 17.0698 19.5633C18.9954 20.7323 18.2492 24.0855 16.2331 25.0907C14.7697 25.8203 11.9917 26.1604 8.25132 27.6018C6.5193 28.2692 5.32315 28.9009 3.53161 30.4302C3.24019 30.6789 3.72588 31.3341 4.04684 31.1248C6.44166 29.5636 8.78298 28.8577 8.56979 29.9711C8.56571 29.9924 8.56079 30.0139 8.55504 30.0357C7.96693 32.2652 7.78042 32.9833 9.50043 31.4477C11.0971 30.0222 13.736 27.7624 16.2855 27.6976C19.6109 27.613 24.7492 26.677 27.0642 24.9563C28.2866 24.0477 31.7123 20.8806 33.5017 18.8568C33.9172 18.3869 34.6583 17.9077 35.207 17.6039C35.6823 17.3407 35.2148 17.2275 34.6756 17.1611C33.2315 16.9832 33.5266 16.7164 32.3309 16.4874Z"
                        fill="#2496FF"
                    />
                    <path
                        d="M32.3309 16.4874C30.0964 16.0595 28.4554 17.3322 27.5152 18.0178C27.2975 18.1448 27.0187 18.1044 26.8604 17.9083C25.9322 16.7585 25.8841 15.9931 20.0941 14.1443C12.1938 11.6216 5.52208 7.75063 5.33555 8.7248C5.14901 9.69896 10.4212 15.9884 16.0755 19.0013C16.4597 19.2061 16.7879 19.3921 17.0698 19.5633C18.9954 20.7323 18.2492 24.0855 16.2331 25.0907C14.7697 25.8203 11.9917 26.1604 8.25132 27.6018C6.5193 28.2692 5.32315 28.9009 3.53161 30.4302C3.24019 30.6789 3.72588 31.3341 4.04684 31.1248C6.44166 29.5636 8.78298 28.8577 8.56979 29.9711C8.56571 29.9924 8.56079 30.0139 8.55504 30.0357C7.96693 32.2652 7.78042 32.9833 9.50043 31.4477C11.0971 30.0222 13.736 27.7624 16.2855 27.6976C19.6109 27.613 24.7492 26.677 27.0642 24.9563C28.2866 24.0477 31.7123 20.8806 33.5017 18.8568C33.9172 18.3869 34.6583 17.9077 35.207 17.6039C35.6823 17.3407 35.2148 17.2275 34.6756 17.1611C33.2315 16.9832 33.5266 16.7164 32.3309 16.4874Z"
                        fill="url(#paint0_linear_1679_154)"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_ii_1679_154"
                        x="6.25"
                        y="4.88061"
                        width="28.0284"
                        height="29.1819"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dx="0.528447" dy="-1.05689" />
                        <feGaussianBlur stdDeviation="1.51928" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                        <feBlend mode="multiply" in2="shape" result="effect1_innerShadow_1679_154" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="0.625" />
                        <feGaussianBlur stdDeviation="0.3125" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="effect1_innerShadow_1679_154" result="effect2_innerShadow_1679_154" />
                    </filter>
                    <filter
                        id="filter1_i_1679_154"
                        x="8.95369"
                        y="2.32649"
                        width="21.3661"
                        height="19.8388"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.55738" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.858333 0 0 0 0 0.95841 0 0 0 0 1 0 0 0 1 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1679_154" />
                    </filter>
                    <clipPath id="bgblur_0_1679_154_clip_path" transform="translate(-8.95369 -2.32649)">
                        <path d="M18.4699 17.59C20.8253 20.0299 26.7955 17.7783 27.7242 19.5697C27.0688 18.1151 27.6931 17.6144 23.0764 14.3728C17.3057 10.3209 12.0008 4.19921 11.5832 4.99216C11.1656 5.7851 14.6684 13.6521 18.4699 17.59Z" />
                    </clipPath>
                    <filter
                        id="filter2_i_1679_154"
                        x="0.84651"
                        y="5.97529"
                        width="37.1529"
                        height="28.8849"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.55738" />
                        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.858333 0 0 0 0 0.95841 0 0 0 0 1 0 0 0 1 0" />
                        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1679_154" />
                    </filter>
                    <clipPath id="bgblur_1_1679_154_clip_path" transform="translate(-0.84651 -5.97529)">
                        <path d="M32.3309 16.4874C30.0964 16.0595 28.4554 17.3322 27.5152 18.0178C27.2975 18.1448 27.0187 18.1044 26.8604 17.9083C25.9322 16.7585 25.8841 15.9931 20.0941 14.1443C12.1938 11.6216 5.52208 7.75063 5.33555 8.7248C5.14901 9.69896 10.4212 15.9884 16.0755 19.0013C16.4597 19.2061 16.7879 19.3921 17.0698 19.5633C18.9954 20.7323 18.2492 24.0855 16.2331 25.0907C14.7697 25.8203 11.9917 26.1604 8.25132 27.6018C6.5193 28.2692 5.32315 28.9009 3.53161 30.4302C3.24019 30.6789 3.72588 31.3341 4.04684 31.1248C6.44166 29.5636 8.78298 28.8577 8.56979 29.9711C8.56571 29.9924 8.56079 30.0139 8.55504 30.0357C7.96693 32.2652 7.78042 32.9833 9.50043 31.4477C11.0971 30.0222 13.736 27.7624 16.2855 27.6976C19.6109 27.613 24.7492 26.677 27.0642 24.9563C28.2866 24.0477 31.7123 20.8806 33.5017 18.8568C33.9172 18.3869 34.6583 17.9077 35.207 17.6039C35.6823 17.3407 35.2148 17.2275 34.6756 17.1611C33.2315 16.9832 33.5266 16.7164 32.3309 16.4874Z" />
                    </clipPath>
                    <linearGradient id="paint0_linear_1679_154" x1="13.0373" y1="0.312972" x2="21.6741" y2="37.0914" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#EFF1FF" />
                        <stop offset="1" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </SvgIcon>
    );
};

export default AdminHeaderLogoIcon;
